<div class="overlay"></div>

<div class="panel">
  <div class="inside-panel">
    <!-- Normal confirmation mode -->
    @if (!isMissingVatOrFiscal) {
      <div class="header">
        <h2>Attenzione</h2>
        <span
          >Controlla con attenzione i dati: partita IVA e codice fiscale non
          saranno più modificabili, se non contattando il supporto. Assicurati
          di essere il titolare: fornire dati falsi è reato.</span
        >
      </div>
      <div class="content">
        <div class="content-items">
          @for (item of businessDataLabelAndValue; track item) {
            <div class="content-item">
              <span class="label">{{ labelService.getLabel(item.label) }}</span>
              <span class="value">{{ item.value }}</span>
            </div>
          }
        </div>
      </div>
      <div class="panel-buttons">
        <button class="button-white" mat-stroked-button (click)="onCancel()">
          {{ labelService.getLabel("cancel") }}
        </button>
        <button class="button-white" mat-raised-button (click)="onConfirm()">
          {{ labelService.getLabel("confirm") }}
        </button>
      </div>
    } @else {
      <div class="header">
        <h2>Attenzione</h2>
        <span
          >Per poter salvare i dati identificativi è necessario specificare sia
          la partita IVA sia il proprio codice fiscale</span
        >
      </div>
      <div class="panel-buttons">
        <button class="button-white" mat-stroked-button (click)="onCancel()">
          {{ labelService.getLabel("cancel") }}
        </button>
      </div>
    }

    <!-- Missing VAT or fiscal code: only show message + cancel -->
  </div>
</div>
